// extracted by mini-css-extract-plugin
module.exports = {"container_landing_benefits":"LandingBenefitsLayout_container_landing_benefits__6QWY_"};